import { getBaseUrl } from '@shared';

export function clientUserSignInLinkByEmail(clientEmail?: string): string {
  if (!clientEmail) return `${getBaseUrl()}/client/login`;
  const params = new URLSearchParams({
    email: clientEmail,
    redirect_to: '/client/home',
  });
  return `${getBaseUrl()}/client/login?${params.toString()}`;
}
